import React from 'react';
import { Trans, useTranslation } from 'react-i18next'
import { PermissionBlock } from '@pokemon/design.ui.containers.permission-block';

const pokemonGoPermissionsPanels = [
  props => {
    const {t} = useTranslation()

    return <PermissionBlock 
      title={t('permission_title_friends', 'Friends')}
      description={<Trans 
        t={t}
        i18nKey='permission_description_friends'
        defaults='Allow your child access to the Friend List and related features. We will send you a daily email with your child’s new friends. Your child can send Gifts, trade, and remotely battle with friends. Friends will see your child’s Trainer profile and limited information about the location where your child initially collected Pokémon Gifts. For more information about the Friend List feature, <friendsListInformationLink>click here</friendsListInformationLink>.'
        components={{ friendsListInformationLink: <a href="https://niantic.helpshift.com/hc/en/6-pokemon-go/section/60-friends-gifting-trading/" /> }}
      />}
      {...props}
    />
  },
  props => {
    const {t} = useTranslation()

    return <PermissionBlock 
      title={t('permission_title_party_play', 'Party Play')}
      description={<Trans 
        t={t}
        i18nKey='permission_description_party_play'
        defaults="Allow your child to access the Party Play feature (group play sessions). Your child will only be able to participate in a party if the Host is on their Friend List. Your child will not be able to share location with other Party Members. We will send you a daily email with your child's Party Play activity. For more information about Party Play, <partyPlayInformationLink>click here</partyPlayInformationLink>."
        components={{ partyPlayInformationLink: <a href="https://niantic.helpshift.com/hc/faq/4171-what-is-party-play-and-how-do-i-use-it" /> }}
      />}
      {...props}
    />
  },
  props => {
    const {t} = useTranslation()

    return <PermissionBlock 
      title={t('permission_title_sponsored_content', 'Sponsored Content')}
      description={<Trans 
        t={t}
        i18nKey='permission_description_sponsored_content'
        defaults='Allow your child to access sponsored in-game content featuring external companies as a form of promotion, such as in-game locations, items, or gameplay. Your child’s information will not be shared with third-party sponsors. For more information about sponsored content, <sponsoredContentInformationLink>click here</sponsoredContentInformationLink>.'
        components={{ sponsoredContentInformationLink: <a href="https://niantic.helpshift.com/hc/en/6-pokemon-go/faq/3626-sponsored-gifts/" /> }}
      />}
      {...props}
    />
  },
]

export default pokemonGoPermissionsPanels
